import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import logoSPRS from '@/assets/SPRS_logo_yoko.png';
import logoRoboRobo from '@/assets/logo-yoko.png';
import { authInformationState } from '@/recoil/atoms/authInformationState';
import { authCode } from '@/shared/constants/code';

/**
 * サービス種別に応じたロゴパスを返すカスタムフック
 *
 * - authInformationState から serviceKind を取得
 * - serviceKind=2: SPRSロゴ、それ以外: RoboRoboロゴ
 */
export const useLogoPath = (): string => {
  const authInfo = useRecoilValue(authInformationState);

  return useMemo(() => {
    return authInfo?.serviceKind === authCode.serviceKind.SPRS ? logoSPRS : logoRoboRobo;
  }, [authInfo?.serviceKind]);
};
